import {
  Accessibility,
  BarChart3,
  BookOpen,
  Bot,
  CheckSquare,
  MessageSquare,
} from 'lucide-react';

import { FeatureCard } from '../components/FeatureCard';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './FeaturesGridSection.module.css';

const features = [
  {
    body: 'Full course content with embedded videos, interactive examples, and accessible digital formatting. Built from OpenStax and original Kudu content.',
    icon: BookOpen,
    title: 'Modern textbook',
  },
  {
    body: 'Question banks with randomized variables, multiple attempts, and instant feedback. LaTeX support for math and science.',
    icon: CheckSquare,
    title: 'Homework with auto-grading',
  },
  {
    body: 'Grounded in your textbook, so students learn from accurate answers, not hallucinated ones. Independently validated by CEILS at UCLA.',
    icon: Bot,
    title: 'Course-aware AI tutor',
  },
  {
    body: 'Replace iClicker. Students respond from any phone or laptop. No extra purchases.',
    icon: BarChart3,
    title: 'In-class polling',
  },
  {
    body: 'Built to WCAG 2.1 AA across the platform. Our proprietary video player makes any embedded YouTube video accessible. No third-party bolt-ons.',
    icon: Accessibility,
    title: 'Accessibility built in',
  },
  {
    body: 'Edit any section. Add your own questions, videos, and links to make the course yours. Or leave it: the pre-built version works too.',
    icon: MessageSquare,
    title: 'Customize freely',
  },
] as const;

export function FeaturesGridSection() {
  return (
    <SectionWrapper background="white" data-testid="faculty-section-features">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>WHAT&apos;S INCLUDED</p>
          <h2 className={styles.title}>Everything your class needs. One platform.</h2>
          <p className={styles.subhead}>
            Kudu replaces the publisher textbook, the homework system, the
            clicker app, and the AI subscription your students would otherwise
            be paying for separately.
          </p>
        </div>

        <div className={styles.grid}>
          {features.map((feature) => (
            <FeatureCard key={feature.title} {...feature} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
